import React from "react";
import { Link } from "react-router-dom";
export const BrandHeader = () => {
  return (
    <header
      className="w-full pt-10 sm:pt-14 pb-2"
      data-testid="brand-header"
    >
      <div className="bp-container flex flex-col items-center text-center">
        <Link
          to="/"
          className="inline-flex flex-col items-center gap-3 group"
          data-testid="brand-home-link"
        >
          <img
            src={LOGO_URL}
            alt="Build Partner Logo"
            className="w-14 h-14 sm:w-16 sm:h-16 object-contain"
            data-testid="brand-logo"
          />
          <span
            className="font-[Manrope] text-base sm:text-lg font-bold tracking-[0.18em] uppercase text-[#0A2540]"
            data-testid="brand-name"
          >
            Build Partner
          </span>
        </Link>
      </div>
    </header>
  );
};

export default BrandHeader;
